import { autocomplete } from '../autocomplete'

export default function addressAutocomplete (document, moduleHTML, appEventEmitter) {
  autocomplete({ inputEl: moduleHTML, types: ['address'], fields: ['address_components'], onAutocompleteSelect })
  const noFormat = Boolean(moduleHTML.dataset.jsAutocompleteNoFormat)

  // Maps google response names to what Form Fields expect
  const addressFieldsMap = {
    street_number: 'streetAddress',
    route: 'streetName',
    locality: 'city',
    administrative_area_level_1: 'state',
    postal_code: 'postalCode'
  }

  function onAutocompleteSelect (place) {
    if (place && Object.hasOwnProperty.call(place, 'name')) {
      // if place.name exists then the user has not selected a place from autocomplete dropdowm. So do nothing
      return
    }
    const {streetAddress, streetName, state, postalCode, city} = place.address_components.reduce((accumulator, { types, short_name, long_name }) => { // eslint-disable-line
      if (addressFieldsMap[types[0]]) {
        accumulator[addressFieldsMap[types[0]]] = short_name || long_name // eslint-disable-line
      }

      return accumulator
    }, { streetAddress: '', streetName: '', state: '', postalCode: '', city: '' })

    if (noFormat) {
      moduleHTML.value = [`${streetAddress} ${streetName}`, city, state, postalCode].join(', ')
      return
    }

    if (streetAddress && streetName) {
      moduleHTML.value = `${streetAddress} ${streetName}`
    }
  }
}
